import React, {Component} from 'react';
import FormControl from "@material-ui/core/es/FormControl/FormControl";
import FormHelperText from "@material-ui/core/es/FormHelperText/FormHelperText";
import CustomInput from "../material-pro/CustomInput/CustomInput";
import withStyles from "@material-ui/core/es/styles/withStyles";
import reduxFieldStyles from "../../assets/jss/reduxFields/ReduxField";
import Grow from "@material-ui/core/es/Grow/Grow";

class ReduxInsideLabelTextField extends Component {
    render() {
        const {input, label, meta, explanation, classes, required, ...rest} = this.props;
        return (
            <FormControl error={meta.error && meta.touched} fullWidth>
                <CustomInput
                    id={input.name}
                    labelText={<span>{label} {(required ? ' *' : '')}</span>}
                    formControlProps={{fullWidth: true}}
                    inputProps={{...input, ...rest}}
                    // classes={{formControl: classes.inlineFormControl}}
                    error={meta.error && meta.touched}
                />
                {meta.error && meta.touched &&
                <Grow in={meta.error && meta.touched}>
                    <FormHelperText>{meta.error}</FormHelperText>
                </Grow>}
                {/*{explanation && <InfoArea description={explanation} />}*/}
            </FormControl>
        )
    }
}

export default withStyles(reduxFieldStyles)(ReduxInsideLabelTextField)



// WEBPACK FOOTER //
// ./src/components/reduxFields/ReduxInsideLabelTextField.js